module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_34.ce21dc3c.png";